import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputSignature from '../../../FormFields/Signature';
import InputSelect from '../../../FormFields/Select';

import Checkbox from '../../../FormFields/Checkbox';
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class SignatureWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api.getFieldsVerbiage(internalField, 'description') }
                   onChange={ (v) => changeFieldValue('description', v) }/>

        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
        </div>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, isCompact, value, error, onChange, onError } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Signature Input',
    };
    return (
      <WrapperWidget {...props}>
        <div className='SignatureWidget'>
          <InputSignature
            disabled={ field.disabled }
            required={ field.required }
            onChange={ onChange }
            onError={ onError }
            value={ value }
            compact={ isCompact }
            error={error}
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const SignatureWidgetEditable = withConditionsAndTriggers(SignatureWidget);
